export const AssessmentStates = {
  assessment_started: Symbol(1),
  pathway_calibration_start: Symbol(2),
  pathway_calibration_audio_completed: Symbol(3),
  ready_to_start_test: Symbol(4),
  start_gesture_detected: Symbol(5),
  test_in_progress: Symbol(6),
  test_complete: Symbol(7),
  assessment_interrupted: Symbol(8),
};

export const TUGAssessmentStates = {
  PathwayCalibration: Symbol(0),
  assessment_started: Symbol(1),
  calculatingDepth: Symbol(2),
  depthCalculated: Symbol(3),
  MoveInsidebox: Symbol(4),
  ready_to_start_test: Symbol(5),
  start_gesture_detected: Symbol(6),
  test_in_progress: Symbol(7),
  ReturnToStart: Symbol(8),
  test_complete: Symbol(9),
  assessment_interrupted: Symbol(10),
  SitToStart: Symbol(11),
};

export const GaitAudios = {
  stand_in_starting_area: Symbol(0),
  pathway_calibration_start: Symbol(1),
  calibrated: Symbol(2),
  raise_arm_to_start_audio: Symbol(3),
  assessment_go_audio: Symbol(4),
  assessment_complete: Symbol(5),
  assessment_interrupted: Symbol(6),
  pathway_blocked: Symbol(7),
  return_to_start_area: Symbol(8),
};

export const TugAudios = {
  calibrating: Symbol(0),
  calibrated: Symbol(1),
  calibration_complete_stand_within_box: Symbol(2),
  place_chair_behind_patient: Symbol(3),
  participant_detected: Symbol(4),
  raiseHand_to_start_and_turn_back: Symbol(5),
  go: Symbol(6),
  assessment_complete: Symbol(7),
  pathway_blocked: Symbol(8),
  assessment_interrupted: Symbol(9),
  return_to_start_area: Symbol(10),
};

export const FunctionalReachAudios = {
  participant_should_stand_with_in_the_starting_box: Symbol(0),
  calibration_1: Symbol(1),
  hand_orientation: Symbol(2),
  hand_orientation_2: Symbol(3),
  readyState: Symbol(4),
  you_have_15_seconds_to_perform_this_movement: Symbol(5),
  phaseCompletion: Symbol(6),
  beepSound: Symbol(7),
  assessment_interrupted: Symbol(8),
  you_have_10_seconds_to_perform_this_movement: Symbol(9),
  participant_detected: Symbol(10),
};

export const SitStandAssessmentStates = {
  begin_assessment: Symbol(0),
  with_in_bounds: Symbol(1),
  stand_gesture_issued: Symbol(2),
  is_patient_sitting: Symbol(3),
  patient_seated_completely: Symbol(4),
  about_to_start_test: Symbol(5),
  begin_test: Symbol(6),
  test_complete: Symbol(7),
  assessment_interrupted: Symbol(8),
  before_with_in_bounds: Symbol(9),
};

export const UpperBodyAromAssessmentStates = {
  begin_assessment: Symbol(0),
  with_in_bounds: Symbol(1),
  raise_the_hand: Symbol(12),
  calibrated: Symbol(2),
  calibration_1: Symbol(3),
  hand_orientation: Symbol(13),
  abduction_adduction_calibration_2: Symbol(4),
  abduction_adduction_calibration_3: Symbol(5),
  abduction_adduction_calibration_4: Symbol(6),
  pre_assessment: Symbol(14),
  abduction_adduction_assessment: Symbol(7),
  post_abduction_adduction_modal: Symbol(8),
  all_sub_assessments_complete: Symbol(9),
  test_complete: Symbol(10),
  assessment_interrupted: Symbol(11),
};

export const mCTSIBAssessmentStates = {
  PathwayCalibration: Symbol(0),
  MoveInsidebox: Symbol(1),

  begin_assessment: Symbol(2),
  with_in_bounds: Symbol(3),
  calibration_1: Symbol(4),
  raise_hand: Symbol(5),
  gesture_detection: Symbol(6),
  pre_assessment: Symbol(7),
  assessment_In_progress: Symbol(8),
  post_assessment_modal: Symbol(9),
  all_sub_assessments_complete: Symbol(10),
  test_complete: Symbol(11),
  assessment_interrupted: Symbol(12),

  calibrated: Symbol(13),
  calculatingDepth: Symbol(14),
  pathwayBlocked: Symbol(14),
};

export const FunctionalReachStates = {
  begin_assessment: 0,
  InitialModal: 1,
  PhaseMessageModal: 2,
  GifMessageModal: 3,
  showReadyModal: 4,
  raiseHand: 5,
  pre_assessment: 6,
  test_complete: 7,
  assessment_interrupted: 8,
  hand_orientation: 9,
  hand_orientation_2: 10,
  readyState: 11,
  assessment_started: 12,
  post_assessment_modal: 13,
  calibration_1: 14,
  all_assessments_complete: 15,
  go_state: 16,
};
